// Legacy mirror tables — shared bounds (ADR-138).
//
// Dependency-free on purpose: `db/schema.ts` imports these the way it imports
// the member-migration vocabulary, so the Drizzle tables and any future wire
// schema derive the same bounds from one place. The tables themselves live in
// `db/schema.ts`, never here (the reverse edge would be a cycle).

import { MEMBER_MIGRATION_SNAPSHOT_REF_MAX_LENGTH } from '../member-migration/schema';

/**
 * Character bound on every mirrored text column. MySQL's `TEXT` ceiling and the
 * zero-ETL varchar limit are both 65,535 bytes; bounding characters is the
 * defensive shape for `mediumtext`/`longtext` sources whose DDL width the
 * register does not record.
 */
export const LEGACY_MIRROR_TEXT_MAX_LENGTH = 65535;

/** A mirror row carries the same opaque snapshot reference the member marker records. */
export const LEGACY_MIRROR_SNAPSHOT_REF_MAX_LENGTH = MEMBER_MIGRATION_SNAPSHOT_REF_MAX_LENGTH;

/** `legacy_<source_table>` — the source table name, snake_case, under the mirror prefix. */
export const LEGACY_MIRROR_TABLE_NAME_PATTERN = /^legacy_[a-z][a-z0-9_]*$/;

/**
 * 1.0 source tables whose names are singular. Their mirrors keep the verbatim
 * name (`legacy_<source_table>`), so the plural-table lint exempts exactly
 * these; the mirror register is pinned against this list.
 */
export const LEGACY_MIRROR_SINGULAR_SOURCES = [
  'primary_diagnosis',
  'secondary_diagnosis',
  'consultations_follow_up',
  'typical_opioid_use',
  'typical_substance_use',
  'test_results_urine',
  'emergency_surgery_detail',
  'history_of_substance_use',
  'medical_assessment',
  'medical_information',
  'medication_experience',
  'oud_member_history',
  'user_treatment_activity',
  'baseline',
  // `baseline_cannabis` is singular too, but ends in `s`, so the lint never
  // flags it and it is deliberately absent here.
  'baseline_alcohol',
  'baseline_opioid',
  'baseline_stimulant',
  'user_provider_history',
  'user_personal_information',
] as const;
